
<script>
    import { buttonStates } from '@repo/config/Global';

    /**
     * @typedef {Object} Props
     * @property {boolean} [disabled]
     * @property {any} [state]
     * @property {any} title
     * @property {any} color
     * @property {any} icon
     * @property {any} background
     * @property {any} [rolloverTitle]
     * @property {string} [align]
     * @property {string} [size]
     */
    let {
        disabled = false,
        state = buttonStates.NEUTRAL,
        title = null,
        icon,
        color = null,
        background = null,
        rolloverTitle = null,
        align = 'left',
        size = 'normal',
        onclick = () => {},
    } = $props();

    function handleClick(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!disabled) {
            onclick(e);
        }
    }
    
</script>

<button
    onclick={handleClick}
    class="icon-button {!disabled ? 'interactive' : 'disabled'} {state} {size}"
    {disabled}
    title={rolloverTitle || title}
    aria-label={rolloverTitle || title}
    style="--color:{color}; --background:{background};"
    type="button"
>
    {#if align === 'left'}
        <i class="material-icons" aria-hidden="true">{icon}</i>
    {/if}
    {#if title}
        <span class={align}>{title}</span>
    {/if}
    {#if align === 'right'}
        <i class="material-icons" aria-hidden="true">{icon}</i>
    {/if}
</button>


<style>
    .icon-button{
        display:flex;
        align-items:center;
        flex-shrink:0;
        padding:0.5rem;
        border-radius:0.5rem;

        color:var(--color);
        background-color: var(--background);
    }

    .icon-button.small{
        padding:0.25rem 0.5rem;
        border-radius:0.35rem;
        font-size:0.75rem;

        i {
            font-size: 1rem;
        }
    }

    .icon-button span{
        text-transform:uppercase;
        font-weight:600;
        font-size:0.8rem;
        padding:0 0.5rem;
        line-height: 20px;
    }

    .icon-button.disabled{
        opacity:0.5;
    }

    .icon-button:not(:last-of-type){
        margin-right:0.5rem;
    }

    .icon-button:hover{
        opacity:0.7;
        box-shadow:0 0.25rem 0.5rem rgba(0,0,0,0.25);
    }

    .icon-button i{
        font-size:1.3rem;
        
    }

    .button_state_error{
        background-color:crimson;
        color:white;
    }

    .button_state_warn{
        background-color:rgb(255, 192, 74);
        color:#333;
    }

    .button_state_waiting{
        background-color:rgb(74, 198, 255);
        color:#333;
    }

    .button_state_neutral{
        background-color:rgb(199, 199, 199);
        color:#333;
    }
    .button_state_success{
        background-color:rgb(74, 255, 83);
        color:#333;
    }


</style>